import Reflux from 'reflux';

const NodesActions = Reflux.createActions({
  list: { asyncResult: true },
});

export default NodesActions;



// WEBPACK FOOTER //
// ./src/actions/nodes/NodesActions.js